import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles, Theme, createStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        fieldList: {
            margin: theme.spacing(1, 0, 0),
            paddingLeft: theme.spacing(2.5),
            columnCount: 2,
        },
        actions: {
            padding: theme.spacing(1, 3, 2),
            gap: theme.spacing(1),
            flexWrap: 'wrap',
        },
        discardButton: {
            color: theme.palette.error.main,
        },
    }),
);

interface UnsavedDetailsFollowUpDialogProps {
    fieldLabels: string[];
    onGoBack: () => void;
    onSaveFollowUpOnly: () => void;
}

// Shown when Save follow-up is pressed while the Details have changes that are not saved: saving the follow-up alone would lose them.
export const UnsavedDetailsFollowUpDialog: React.FC<UnsavedDetailsFollowUpDialogProps> = ({ fieldLabels, onGoBack, onSaveFollowUpOnly }) => {
    const classes = useStyles();

    return (
        <Dialog open={true} onClose={onGoBack} maxWidth="xs" fullWidth={true}>
            <DialogTitle>Details changes aren't saved</DialogTitle>
            <DialogContent>
                <DialogContentText component="div">
                    You have changed these fields in the enquiry details. They will be lost if you save the follow-up now. Go back and press Save to keep them first.
                    <ul className={classes.fieldList}>
                        {fieldLabels.map((fieldLabel) => (
                            <li key={fieldLabel}>{fieldLabel}</li>
                        ))}
                    </ul>
                </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button className={classes.discardButton} onClick={onSaveFollowUpOnly}>Save follow-up anyway</Button>
                <Button variant="contained" color="primary" onClick={onGoBack} autoFocus={true}>Go back</Button>
            </DialogActions>
        </Dialog>
    );
};
